import { initClient, initClientNavigation } from "rwsdk/client";

initClient();

initClientNavigation();
